const DEFAULT_STORAGE_KEY = "ferrivia.install-prompt";

interface DismissRecord {
  dismissedAt?: number;
}

export interface InstallDismissStore {
  isDismissed(): boolean;
  markDismissed(): void;
}

export function createInstallDismissStore(storageKey = DEFAULT_STORAGE_KEY): InstallDismissStore {
  function read(): DismissRecord {
    try {
      const raw = localStorage.getItem(storageKey);
      if (!raw) return {};
      const parsed: unknown = JSON.parse(raw);
      return parsed && typeof parsed === "object" ? (parsed as DismissRecord) : {};
    } catch {
      // Unavailable or corrupt storage — the prompt just shows once more,
      // which is the safe failure direction.
      return {};
    }
  }

  function isDismissed(): boolean {
    return typeof read().dismissedAt === "number";
  }

  function markDismissed(): void {
    try {
      localStorage.setItem(storageKey, JSON.stringify({ dismissedAt: Date.now() }));
    } catch {
      // see read
    }
  }

  return { isDismissed, markDismissed };
}
